import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: {
    EMTCSLP_EXTERNAL_APIGATEWAY_PROD,
    EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA
  }
} = constants;

const urls = {
  getAsinPriceRanges: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/recommend/priceRanges`, // get Add-on Asin price ranges for display
  getRecommendAsins: `${EMTCSLP_EXTERNAL_APIGATEWAY_GAMMA}/recommend/asins` // get recommend Asins
};
export const RECOMMENDATION_TYPE = {
  CATEGORY: 1, // Obtained through categories
  PRICE_TAG: 2 // Obtained through price tags
};
export const getAsinPriceRanges = params =>
  aHttp.get(urls.getAsinPriceRanges, params);

export const getRecommendAsins = params =>
  aHttp.get(urls.getRecommendAsins, params);
